const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
	resultsAlt: 3,
};

document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	cards: [
		{
			id: 1,
			value: "Je ressens<br />une douleur,<br />une raideur<br />ou un gonflement<br />des articulations",
			pos: 1,
		},
		{
			id: 2,
			value: "Je suis orienté(e)<br />vers un<br />rhumatologue",
			pos: 4,
			altPos: 3,
		},
		{
			id: 3,
			value: "Je consulte<br />mon médecin<br/>traitant",
			pos: 2,
		},
		{
			id: 4,
			value: "Je reçois des<br/>conseils pour<br />mon quotidien",
			pos: 9,
		},
		{
			id: 5,
			value: "J'exprime mes<br />plaintes et je<br />décris ma gêne<br />articulaire",
			pos: 3,
			altPos: 4,
		},
		{
			id: 6,
			value: "Mon<br />rhumatologue<br/>évalue la<br />mobilité de<br />mon articulation",
			pos: 6,
		},
		{
			id: 7,
			value: "Je programme un<br />rendez-vous de<br />suivi",
			pos: 10,
		},
		{
			id: 8,
			value: "Je suis pris(e) en<br />charge de façon<br />adaptée",
			pos: 8,
		},
		{
			id: 9,
			value: "Je réponds<br />aux questions<br />de mon<br/>rhumatologue",
			pos: 5,
		},
		{
			id: 10,
			value: "Je dois<br />éventuellement<br />passer une<br />radiographie",
			pos: 7,
		}
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.initPlayingState();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById('state-results').classList.remove('hidden')
				break;
			case GameState.resultsAlt:
				document.getElementById('state-results-2').classList.remove('hidden');
				break;
		}
	},
	initPlayingState() {
		// Create questions cards
		let cardsHtml = "";
		this.cards.forEach((c, i) => {
			cardsHtml += `<div class="card" data-id="${c.id}" draggable="true">${c.value}</div>`;
		});
		document.getElementById('drag-container').innerHTML = cardsHtml;

		let dropHtml = "";
		for (let i = 0; i < 5; i++) {
			dropHtml += `<div class="drop-zone" data-pos="${i + 1}"></div>`;
		}
		for (let i = 10; i > 5; i--) {
			dropHtml += `<div class="drop-zone" data-pos="${i}"></div>`;
		}
		document.getElementById('drop-container').innerHTML = dropHtml;
		this.handleDragAndDrop();
	},
	showingReply: false,
	selectedItem: null,
	dropped: false,
	foundCount: 0,
	handleDragAndDrop() {
		const cards = document.getElementsByClassName('card');
		const dropZones = document.getElementsByClassName('drop-zone');

		for (let i = 0; i < cards.length; i++) {
			cards[i].addEventListener('dragstart', (ev) => {
				if (this.showingReply) {
					ev.preventDefault();
					return;
				}
				this.selectedItem = cards[i];
				this.dropped = false;
				ev.dataTransfer.dropEffect = "move";

				// So it's called after dragstart ends and the item is copied without the class
				setTimeout(() => {
					this.selectedItem.classList.add('hidden-opacity');
				}, 0);
			});
			cards[i].addEventListener('dragend', (ev) => {
				if (this.dropped) { return; }
				// Called after drop, reset css if not handled in drop
				this.selectedItem.classList.remove('hidden-opacity');
				this.selectedItem = null;
			});
		}

		for (let i = 0; i < dropZones.length; i++) {
			dropZones[i].addEventListener("dragover", (ev) => {
				ev.preventDefault();
				ev.dataTransfer.dropEffect = "move";
			});
			dropZones[i].addEventListener("drop", (ev) => {
				ev.preventDefault();
				if (dropZones[i].innerHTML.length) {
					return; // Zone already contains an item
				}
				this.dropped = true;
				const itemId = +this.selectedItem.dataset.id;
				const zonePos = +dropZones[i].dataset.pos;

				const item = this.cards.find(c => c.id === itemId);
				const success = zonePos === item.pos || zonePos === item.altPos;

				if (success) {
					dropZones[i].classList.add('success');
					dropZones[i].innerHTML = this.selectedItem.innerHTML;
					this.foundCount += 1;
					if (this.foundCount === this.cards.length) {
						setTimeout(this.showSuccessScreen.bind(this), 1000);
					}
					return;
				}
				this.showingReply = true;
				dropZones[i].classList.add('error');
				dropZones[i].innerHTML = this.selectedItem.innerHTML;

				// Show error toastr
				const errorDiv = document.createElement('div');
				errorDiv.innerHTML = "<strong>Oups !</strong> Ce n'est pas ici.";
				errorDiv.setAttribute("id", "error-message");
				dropZones[i].appendChild(errorDiv);

				setTimeout(() => {
					dropZones[i].classList.remove('error');
					dropZones[i].innerHTML = '';
					this.showingReply = false;
					this.selectedItem.classList.remove('hidden-opacity');
					this.selectedItem = null;
				}, 2000);
			});
		}
	},
	answer() {

	},
	restart() {
		this.foundCount = 0;
		this.state = GameState.playing;
		this.render();
	},
	showSuccessScreen() {
		this.state = GameState.done;
		this.render();
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	},
	seeResultsAlt() {
		this.state = GameState.resultsAlt;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
